import React, {
  createContext,
  useContext,
  useState,
  useRef,
  useCallback,
  useEffect,
} from "react";
import axiosInstance from "../Config/axios";
import { Toast } from "primereact/toast";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Loader from "../Components/Loader/Loader";
import {useLogin} from "./LoginContext";

const NewUserContext = createContext();
export const useNewUser = () => useContext(NewUserContext);

export const NewUserContextProvider = ({ children }) => {
  const { user } = useLogin();
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [cartItemsNew, setCartItemsNew] = useState([]);
  const [couponsNew, setCouponsNew] = useState([]);
  const [error, setError] = useState(null);
  const [packageCategories, setPackageCategories] = useState([]);
  const [cartRe, setCartRe] = useState(0);
  const [summercampList, setSummerCampList] = useState([]);
  const [isGuestSummerCampCheckingOut, SetGuestSummerCampCheckingOut] = useState(false);
  const [dataVpaymentGuest, setDataVpaymentGuest] = useState(null);

  const time_Zone = Intl.DateTimeFormat().resolvedOptions().timeZone;

   const addToCart = async (data) => {
    const accessToken = localStorage.getItem("accessToken");
    const headers_data = accessToken
      ? {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      : undefined;
    try {
      setLoading(true);

      const response = await axiosInstance.post(
        "/customer/cart/add/new/",
        data,
        headers_data,
        {
          params: { timezone: time_Zone },
        }
      );
      fetchCartCount();

      // setParentProfile(response.data);
      Swal.fire({
        icon: "success",
        title: "Added to Cart!",
        text: "Your session has been added to the cart successfully.",
        showConfirmButton: true,
        confirmButtonText: "Go to Cart",
        showCancelButton: true,
        cancelButtonText: "Continue Shopping",
        confirmButtonColor: "#f7931a",
        cancelButtonColor: "#1C1C1C",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = "/cart";
        }

        if (result.dismiss === Swal.DismissReason.cancel) {
          window.location.href = "/buy-packages";
        }
      });

      return { success: true, data: response.data };
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Failed",
        text: err.response?.data?.detail || "Something went wrong.",
        confirmButtonColor: "#f7931a",
        cancelButtonColor: "#1C1C1C",
      });

      return { success: false };
    } finally {
      setLoading(false);
    }
  };

  const fetchCartItemsNew = async () => {
    setLoading(true);
    setError(null);

    const accessToken = localStorage.getItem("accessToken");
    const headers_data = accessToken
      ? {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      : undefined;

    try {
      const response = await axiosInstance.get(`/customer/new/list-cart/`, 
        {
          headers_data,
          params: { timezone: time_Zone },
        });
      setCartItemsNew(response.data || []);
      return response.data;
    } catch (err) {
      const errorDetail =
        err.response?.data?.detail || "Failed to fetch packages";
      setError(errorDetail);
      console.log("Error fetching cart items:", errorDetail);
    } finally {
      setLoading(false);
    }
  };


  

  const removeFromCartNew = async (id) => {
    setLoading(true);
    setError(null);
    const accessToken = localStorage.getItem("accessToken");
    const headers_data = accessToken
      ? {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      : undefined;
    const data = { cart_item_id: id };
    try {
      const response = await axiosInstance.post(
        `customer/new/cart-remove/`,
        data, 
        headers_data
      );

      fetchCartCount();
      
      Swal.fire({
        icon: "success",
        title: "Deleted from Cart!",
        text: "Your item has been deleted from the cart successfully.",
        showConfirmButton: true,
        confirmButtonText: "Go to Cart",
        showCancelButton: true,
        cancelButtonText: "Continue Shopping",
        confirmButtonColor: "#f7931a",
        cancelButtonColor: "#1C1C1C",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = "/cart";
        }

        if (result.dismiss === Swal.DismissReason.cancel) {
          window.location.href = "/buy-packages";
        }
      });
      return { success: true, data: response.data };
    } catch (err) {
      const errorDetail = err.response?.data || {
        detail: "Failed to delete Item",
      };
      Swal.fire({
        icon: "error",
        title: "Error !",
        text: `${
          errorDetail.detail || "An error occurred while deleting the Item."
        }`,
        confirmButtonColor: "#f7931a",
        cancelButtonColor: "#1C1C1C",
      });
      return { success: false, error: errorDetail };
    } finally {
      setLoading(false);
    }
  };

  

 

  const removeCuponGuest = async () => {
    setLoading(true);
    setError(null);
    const accessToken = localStorage.getItem("accessToken");
    const headers_data = accessToken
      ? {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      : undefined;

    try {
      const response = await axiosInstance.post(`/customer/v2/remove-coupon/`, headers_data);
      await fetchCartItemsNew();
      Swal.fire({
        icon: "success",
        title: "Success !",
        text: `${response.data?.message || "Coupon removed successfully"}`,
        confirmButtonColor: "#f7931a",
        cancelButtonColor: "#1C1C1C",
      });
      return { success: true, data: response.data };
    } catch (err) {
      const errorDetail = err.response?.data || {
        detail: "Failed to delete Item",
      };
      Swal.fire({
        icon: "error",
        title: "Error !",
        text: `${
          errorDetail.detail || "An error occurred while removeing the Coupon."
        }`,
        confirmButtonColor: "#f7931a",
        cancelButtonColor: "#1C1C1C",
      });
      return { success: false, error: errorDetail };
    } finally {
      setLoading(false);
    }
  };

  const applyCouponNew = async (data) => {
    const accessToken = localStorage.getItem("accessToken");
    const headers_data = accessToken
      ? {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      : undefined;
    try {
      setLoading(true);
      const response = await axiosInstance.post(
        "/customer/v2/apply-coupon/",
        data,
        headers_data,
        {
          params: { timezone: time_Zone },
        }
      );
      return { success: true, data: response.data };
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error !",
        text: `${err.detail || "Invalid coupon"}`,
        confirmButtonColor: "#f7931a",
        cancelButtonColor: "#1C1C1C",
      });
      return { success: false };
    } finally {
      setLoading(false);
    }
  };


  const proceedToCheckoutGuest = async (data) => {
    setLoading(true);

    try {
      // 1️⃣ Validate required email
      if (!data?.parent?.email) {
        Swal.fire({
          icon: "warning",
          title: "Missing Email",
          text: "Email is required to continue",
          confirmButtonColor: "#f7931a",
        });
        return { success: false };
      }

      // 2️⃣ Validate email availability (send ONLY email)
      const validateEmail = await axiosInstance.post(
        "/customer/validate-email/",
        { email: data.parent.email },
        {
          params: { timezone: time_Zone },
        }
      );

      if (!validateEmail.data?.available) {
        Swal.fire({
          icon: "error",
          title: "Email Already Exists",
          text: "This email is already registered.",
          confirmButtonColor: "#f7931a",
        });
        return { success: false };
      }

      // 3️⃣ Proceed to guest checkout
      const response = await axiosInstance.post(
        "/payment/new/checkout/guest/",
        data,
        {
          params: { timezone: time_Zone },
        }
      );

      return { success: true, data: response.data };
    } catch (err) {
      console.error(err);

      return { success: false };
    } finally {
      setLoading(false);
    }
  };

  const proceedToCheckoutUser = async (data) => {
    setLoading(true);

    try {
      
        
      const response = await axiosInstance.post(
        "/payment/new/checkout/",
        data,
        {
          params: { timezone: time_Zone },
        }
      );

      return { success: true, data: response.data };
    } catch (err) {
      console.error(err);

      return { success: false };
    } finally {
      setLoading(false);
    }
  };

  

  const fetchCartCount = async () => {
    const accessToken = localStorage.getItem("accessToken");
    const headers_data = accessToken
      ? {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      : undefined;
    try {
      const response = await axiosInstance.get(`/customer/header-metadata/`,headers_data);
      setCartRe(response.data?.cart_item_count);
      return response.data;
    } catch (err) {
      const errorDetail =
        err.response?.data?.detail || "Failed to fetch cart count";
      setError(errorDetail);
      console.log("Error fetching coupons:", errorDetail);
    } finally {
    }
  };

  const fetchPlayer = async () => {
    setLoading(true);
    setError(null);

    const accessToken = localStorage.getItem("accessToken");
    const headers_data = accessToken
      ? {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      : undefined;

    try {
      const response = await axiosInstance.get(`/customer/player-account/`, 
        {
          headers_data,
          params: { timezone: time_Zone },
        });
      return response.data;
    } catch (err) {
      const errorDetail =
        err.response?.data?.detail || "Failed to fetch packages";
      setError(errorDetail);
      console.log("Error fetching cart items:", errorDetail);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCartCount();
  }, [user]);




  return (
    <NewUserContext.Provider
      value={{
        loading,
        error,
        packages,
        packageCategories,
        addToCart,
        fetchCartItemsNew,
        cartItemsNew,
        removeFromCartNew,
        applyCouponNew,
        proceedToCheckoutGuest,
        proceedToCheckoutUser,
        removeCuponGuest,
        fetchCartCount,
        cartRe,
        summercampList,
        isGuestSummerCampCheckingOut,
        dataVpaymentGuest,
        fetchPlayer
      }}
    >
      {loading && <Loader />}

      {children}
    </NewUserContext.Provider>
  );
};
